/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime'
import type {
  GetDatasetVersionResponse,
  GetDatasetVersionsResponse,
  UpdateActiveDatasetVersionResponse,
} from '../models/index'

export interface CreateDatasetVersionRequest {
  datasetId: string
}

export interface SetDatasetAsActiveVersionRequest {
    datasetId: string;
}

/**
 * 
 */
export class DatasetVersionControllerApi extends runtime.BaseAPI {
  /**
   */
  async createDatasetVersionRaw(
    requestParameters: CreateDatasetVersionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetDatasetVersionResponse>> {
    if (requestParameters['datasetId'] == null) {
      throw new runtime.RequiredError(
        'datasetId',
        'Required parameter "datasetId" was null or undefined when calling createDatasetVersion().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/private/bot/datasets/{datasetId}/version`.replace(
          `{${'datasetId'}}`,
          encodeURIComponent(String(requestParameters['datasetId'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response)
  }

  /**
   */
  async createDatasetVersion(
    requestParameters: CreateDatasetVersionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetDatasetVersionResponse> {
    const response = await this.createDatasetVersionRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   */
  async getDatasetVersionsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetDatasetVersionsResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/private/bot/datasets`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response)
  }

  /**
   */
  async getDatasetVersions(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetDatasetVersionsResponse> {
    const response = await this.getDatasetVersionsRaw(initOverrides)
    return await response.value()
  }

  /**
   */
  async setDatasetAsActiveVersionRaw(
    requestParameters: SetDatasetAsActiveVersionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<UpdateActiveDatasetVersionResponse>> {
    if (requestParameters['datasetId'] == null) {
      throw new runtime.RequiredError(
        'datasetId',
        'Required parameter "datasetId" was null or undefined when calling setDatasetAsActiveVersion().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/private/bot/datasets/{datasetId}/version`.replace(
          `{${'datasetId'}}`,
          encodeURIComponent(String(requestParameters['datasetId'])),
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response)
  }

  /**
   */
  async setDatasetAsActiveVersion(
    requestParameters: SetDatasetAsActiveVersionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<UpdateActiveDatasetVersionResponse> {
    const response = await this.setDatasetAsActiveVersionRaw(requestParameters, initOverrides)
    return await response.value()
  }
}
